<template>
  <div>
    <!-- Header -->
    <div class="header  py-7 py-lg-8 pt-lg-9">
      
    </div>
    <!-- Page content -->
    <div class="container mt--8 pb-5">

      <div slot="brand" class="text-center col-12 p-4">
        <img src="/img/brand/food-drop-logo-white.svg" style="width: 16rem;">
      </div>

      <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7" v-if="codeValid === true">
          <div class="card bg-secondary border-0 mb-0">
            <div class="card-body px-lg-5 py-lg-5">

              <div class="text-center text-muted mb-4">
                <small>Reset your password</small>
              </div>

              <div>
                <base-input alternative
                            class="mb-3"
                            prepend-icon="ni ni-lock-circle-open"
                            type="password"
                            placeholder="New Password"
                            autofocus
                            v-model="model.password"
                            @keypress.enter="doResetPassword()">
                </base-input>

                <div class="text-center">
                  <base-button type="primary" class="my-4" @click="doResetPassword()">Set New Password</base-button>
                </div>
              </div>

            </div>
          </div>

          <div class="row mt-3">
            <div class="col-12 text-left">
              <router-link to="/auth/login" class="text-white"><small><span class="fa fa-arrow-left"></span>&nbsp;&nbsp;Back to login</small></router-link>
            </div>
          </div>

        </div>

        <div class="col-lg-5 col-md-7" v-if="codeValid === false">
          <div class="card bg-secondary border-0 mb-0">
            <div class="card-body px-lg-5 py-lg-5">

              <div class="text-center text-muted mb-4">
                <small>Invalid Link</small>
              </div>

              <div class="text-center">
                This password reset link is invalid. It has most likely expired. {{ this.model.email }}
              </div>

            </div>
          </div>

          <div class="row mt-3">
            <div class="col-12 text-left">
              <router-link to="/auth/login" class="text-white"><small><span class="fa fa-arrow-left"></span>&nbsp;&nbsp;Back to login</small></router-link>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // Services
  import AuthService from '../../../services/AuthService'
  import UsersService from '../../../services/UsersService'
  import UserStore from '../../../services/UserStore'

  export default {
    data() {
      return {
        codeValid: null,
        model: {
          password: ''
        }
      };
    },

    created: async function() {
      if(this.$route.query && this.$route.query.code) {
        this.code = this.$route.query.code;

        if(await AuthService.checkPasswordResetCode(this.code)) {
          this.codeValid = true;
        }
        else {
          this.codeValid = false;
        }
      }
    },

    methods: {
      async doResetPassword() {
        if(await AuthService.resetPassword(this.code, this.model.password)) {
          // Wait for 100ms for http-only cookie to store before making further requests
          setTimeout(async () => {
            try {
              const userRes = await UsersService.getOwn();
  
              UserStore.setUserData(userRes.data);

              // Navigate to the relevant dashboard page
              switch(UserStore.userData.group) {
                case 'admins':
                  this.$router.push('/admin/dashboard');
                  break;

                case 'retailers':
                  this.$router.push('/retailer/dashboard');
                  break;

                case 'retailerLead':
                  this.$router.push('/lead-retailer/dashboard');
                  break;

                case 'charities':
                  this.$router.push('/charity/dashboard');
                  break;

                default:
                  this.$router.push('/404');
                  break;
              }
            }
            catch(err) {
              console.log('Get User Error:', {err});
            }
          }, 100);
        }
        else {
          alert('Oops, something went wrong. Please try again...')
        }
      }
    }
  };
</script>
